module.exports = __webpack_public_path__ + "img/options-aspherical.d1ca9ea7.svg";